import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import CTABand from "../components/CTABand";
import { INDUSTRIES, IMAGES } from "../data/content";

const Industries = () => (
  <main data-testid="industries-page">
    <PageHeader
      eyebrow="Who We Serve"
      title="Industries"
      description="Domain-aware engineering for sectors where reliability, security and compliance readiness matter most."
    />
    <section className="bg-white py-20 lg:py-24">
      <div className="container-site grid items-start gap-14 lg:grid-cols-5">
        <div className="grid gap-6 sm:grid-cols-2 lg:col-span-3">
          {INDUSTRIES.map((industry, i) => (
            <Reveal key={industry.title} delay={(i % 2) * 80}>
              <article
                className="flex h-full items-start gap-4 border border-border p-7 transition-colors duration-200 hover:border-brand-red"
                data-testid={`industry-card-${i}`}
              >
                <industry.icon
                  className="h-7 w-7 shrink-0 text-brand-red"
                  strokeWidth={1.5}
                  aria-hidden="true"
                />
                <div>
                  <h2 className="font-heading text-lg font-semibold">{industry.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-brand-grey">
                    {industry.description}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={150} className="lg:col-span-2">
          <img
            src={IMAGES.building}
            alt="Angular architectural detail of a modern building"
            className="v-clip sticky top-28 aspect-[3/4] w-full object-cover"
            loading="lazy"
            data-testid="industries-image"
          />
        </Reveal>
      </div>
    </section>
    <CTABand />
  </main>
);

export default Industries;
